import React from 'react';
import useAutoLogout from '../../hooks/useAutoLogout';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  useAutoLogout();
  return <>{children}</>;
};

export default AdminLayout;

